// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__22Y-4","title":"ClientInsurance_title__1_a63","itemText":"ClientInsurance_itemText__2q4NF"};